/**
 * Privacy-safe offline cache helpers (D-046).
 *
 * The app-shell worker only caches static/public responses. Logout and
 * account deletion must purge every Kuniri cache; the push worker also gets a
 * message so no stale navigation target survives a session change.
 */
export const CACHE_PREFIX = 'kuniri-'

export async function purgeOfflineCaches(): Promise<void> {
  if (typeof window === 'undefined') return

  try {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.getRegistration('/')
      const worker = registration?.active ?? registration?.waiting
      worker?.postMessage({ type: 'PURGE_CACHES' })
    }
  } catch {
    // Best effort: cache deletion below still runs.
  }

  try {
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(
        keys
          .filter((key) => key.startsWith(CACHE_PREFIX))
          .map((key) => caches.delete(key)),
      )
    }
  } catch {
    // Never surface cache errors to the user or the console.
  }
}
